export default {
  title: 'Edit Job Custom Field',
  menu: 'Edit Job Custom Field',
  label: {
    cnName: 'Chinese Name',
    enName: 'English Name',
    type: 'Type',
    status: 'Status',
    required: 'Required',
    select: 'Multi list',
    text: 'Single-line text',
    single: 'Drop-down list',
    textarea: 'Multi-line text',
    date: 'Date',
    addJobFilter: 'Add New Job Customized Field',
    editJobFilter: 'Edit Job Customized Field',
    cnFieldLabel: 'Field Label (CN)',
    enFieldLabel: 'Field Label (ENG)',
    fieldType: 'Field Type',
    cnFieldValue: 'Field Value (CN)',
    enFieldValue: 'Field Value (ENG)',
    addOption: 'Add Field Value',
    editOption: 'Edit Field Value',
    visibleOnlyMember: 'Visible To Job Creator And Team Member Only'
  },
  placeholder: {
    cnFieldLabel: 'Please Input field label (CN)',
    enFieldLabel: 'Please input field label (ENG)',
    cnFieldValue: 'Please Input field value (CN)',
    enFieldValue: 'Please input field value (ENG)',
    fieldType: 'Please select field type'
  },
  message: {
    deleteOption: 'Are you sure you want to delete the field value {cnName} - {name} ?'
  }
}
